/**
 * 저장 안 한 초안 이동 배너(페이지 로컬, T12~T15·D-19). 브라우저 confirm 금지(화면 안 배너).
 * @spec:2026-09-29-처방검토-판정기록-조회화면
 */
import React from "react";
import Button from "components/atoms/Button";
import { unsavedBannerText, DISCARD_LABEL, STAY_LABEL } from "utils/doseReviewLabels";
import { UnsavedBannerBox, BannerText, BannerActions } from "./labelStyle";

const UnsavedBanner: React.FC<{ count: number; onDiscard: () => void; onStay: () => void }> = ({
  count,
  onDiscard,
  onStay,
}) => (
  <UnsavedBannerBox data-testid="dose-unsaved-banner" role="alert">
    <BannerText>{unsavedBannerText(count)}</BannerText>
    <BannerActions>
      <Button
        data-testid="dose-unsaved-discard"
        buttonType="button"
        type="Text"
        size="Small"
        variant="Contained"
        color="Primary"
        onClick={onDiscard}
      >
        {DISCARD_LABEL}
      </Button>
      <Button
        data-testid="dose-unsaved-stay"
        buttonType="button"
        type="Text"
        size="Small"
        variant="Outlined"
        color="Secondary"
        onClick={onStay}
      >
        {STAY_LABEL}
      </Button>
    </BannerActions>
  </UnsavedBannerBox>
);

export default UnsavedBanner;
